/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */
/* eslint-disable no-use-before-define */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-cycle
import App from './App';

const Routes = ():JSX.Element => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

export default Routes;
